export enum Paymethods {
	pay = 'pay',
	free = 'free',
}
